import { inject, Pipe, PipeTransform } from '@angular/core';
import { LogsService } from '@shared/services/logs';

@Pipe({
  name: 'consoleLog',
  standalone: true,
})
export class ConsoleLogPipe implements PipeTransform {
  private readonly logs = inject(LogsService);

  transform<T>(value: T): T {
    this.logs.info('ConsoleLogPipe', value);
    return value;
  }
}
